var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 16.6665V11.6665C4.16717 11.2064 4.53987 10.8335 5 10.8335C5.46013 10.8335 5.83283 11.2064 5.83301 11.6665V16.6665C5.83301 17.1267 5.46024 17.5005 5 17.5005C4.53976 17.5005 4.16699 17.1267 4.16699 16.6665ZM9.16699 16.6665V3.3335C9.16699 2.87326 9.53976 2.50049 10 2.50049C10.4602 2.50049 10.833 2.87326 10.833 3.3335V16.6665C10.833 17.1267 10.4602 17.5005 10 17.5005C9.53976 17.5005 9.16699 17.1267 9.16699 16.6665ZM14.167 16.6665V8.3335C14.167 7.87326 14.5398 7.50049 15 7.50049C15.4602 7.50049 15.833 7.87326 15.833 8.3335V16.6665C15.833 17.1267 15.4602 17.5005 15 17.5005C14.5398 17.5005 14.167 17.1267 14.167 16.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.7b20cc3ed3dd64b625bf5fa4db341090.svg";
export { ForwardRef as ReactComponent };